module.exports = __webpack_public_path__ + "QuicKitchen.png?b6914cfea5e9a706abb9734a92b11303";


//////////////////
// WEBPACK FOOTER
// ./src/assets/QuicKitchen.png
// module id = 42
// module chunks = 0